import { NavLink } from "react-router-dom";
import { ChevronsLeft, ChevronsRight } from "lucide-react";
import { Mark, Wordmark } from "@/components/ax/Mark";
import { BrandLogo } from "@/components/ax/BrandLogo";
import styles from "@/components/sheet/LembarVisual.module.css";
import { NAV } from "@/components/shell/nav";
import { useI18n } from "@/i18n";

export const Sidebar = ({ collapsed, onToggle, stitch = false }) => {
  const { t } = useI18n();
  const wide = collapsed ? "" : "lg:inline";
  return (
    <aside
      data-testid="app-sidebar"
      className={`fixed inset-y-0 left-0 z-30 hidden w-[72px] flex-col border-r border-white/10 bg-ax-inverse text-white md:flex ${
        collapsed ? "lg:w-[72px]" : "lg:w-[232px]"
      } ${stitch ? `${styles.sidebar} ${collapsed ? styles.collapsedSidebar : ""}` : ""}`}
    >
      <div className={`flex h-14 items-center justify-center gap-3 ${collapsed ? "" : "lg:justify-start lg:px-5"}`}>
        {stitch ? <><span className={styles.compactLogo}><BrandLogo mark /></span><span className={styles.wideLogo}><BrandLogo /></span></> : <><Mark size={24} className="shrink-0 text-white" />
        <span className={`hidden ${wide}`}>
          <Wordmark />
        </span>
        </>}
      </div>
      <nav aria-label={t("nav.main")} className="mt-4 flex flex-col gap-1 px-3">
        {NAV.map(({ key, to, icon: Icon, labelKey, end }) => (
          <NavLink
            key={key}
            to={to}
            end={end}
            title={t(labelKey)}
            data-testid={`sidebar-nav-${key}`}
            className={({ isActive }) =>
              `relative flex min-h-[44px] items-center justify-center gap-3 rounded-[8px] px-3 text-sm font-medium transition-colors duration-150 ${
                collapsed ? "" : "lg:justify-start"
              } ${isActive ? "bg-white/10 text-white" : "text-white/70 hover:bg-white/5 hover:text-white"}`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <span aria-hidden="true" className="absolute inset-y-2 left-0 w-[2px] bg-ax-accent" />
                )}
                <Icon size={20} strokeWidth={1.5} aria-hidden="true" className="shrink-0" />
                <span className={`hidden ${wide}`}>{t(labelKey)}</span>
                <span className={`sr-only ${collapsed ? "" : "lg:hidden"}`}>{t(labelKey)}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="mt-auto hidden px-3 pb-4 lg:block">
        <button
          type="button"
          onClick={onToggle}
          data-testid="sidebar-toggle"
          aria-label={collapsed ? t("nav.expand") : t("nav.collapse")}
          title={collapsed ? t("nav.expand") : t("nav.collapse")}
          className={`flex min-h-[44px] w-full items-center justify-center rounded-[8px] text-white/70 transition-colors duration-150 hover:bg-white/5 hover:text-white ${
            collapsed ? "" : "lg:justify-start lg:px-3"
          }`}
        >
          {collapsed ? (
            <ChevronsRight size={20} strokeWidth={1.5} aria-hidden="true" />
          ) : (
            <ChevronsLeft size={20} strokeWidth={1.5} aria-hidden="true" />
          )}
        </button>
      </div>
    </aside>
  );
};
